export const FOCUSED_ENTRY_ID_QUERY_PARAM = 'focusedEntryId';
